import React from 'react'

export default function Map() {
  return (
    <section className='map'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.3875490335176!2d72.5201255759268!3d23.009538416813367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84a61e7ae701%3A0x88db00c5397985d8!2sKoolMind%20Technolab%20LLP!5e0!3m2!1sen!2sin!4v1690795197665!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
  )
}
